<template>
    <div class="md-layout-item ">
        <h4>Questions</h4>
        <draggable v-model="options_list" group="qestions" @end="saveOption">
            <div v-bind:key="index" v-for="(option, index) in options_list">
                <md-divider></md-divider>

                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-10">
                        <md-icon>reorder</md-icon>
                    </div>
                    <div class="md-layout-item md-size-65">
                        <md-field>
                            <label>Label</label>
                            <md-input v-model="option.label"></md-input>
                        </md-field>
                    </div>
                    
                    <div class="md-layout-item">
                        <md-button @click="removeOption(index)">Remove</md-button>
                    </div>
                </div>
            </div>
        </draggable>
        <md-button class="md-raised md-primary" @click="addOption">Add Section</md-button>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "FbLikertSection",
  props: ["options"],
  components: {
    draggable,
  },
  data() {
    return {
      options_list: this.options,
    };
  },
  methods: {
    saveOption() {
      this.$emit("save-option", this.options_list.slice(0));
    },
    addOption() {
      this.options_list.push({
        label: "",
      });
    },
    removeOption(index) {
      this.options_list.splice(index, 1);
    },
  },
};
</script>